module.exports = __webpack_public_path__ + "media/images/teams/CROTONE-27dbe6aaf35255c1d3fdb12767499a09.png";